<template>
  <div>
    <nav-bar />
    <div class="forum_louzhu">
      <div class="forum_item">
        <div class="user">
          <img :src="[forumLouzhu.mpic]" alt />
          <div class="username">
            <p>{{ forumLouzhu.nickname }}</p>
            <p class="time">{{ forumLouzhu.createtime }}</p>
          </div>
        </div>
        <div class="ForumMain">
          <div class="Forum_content" v-html="forumLouzhu.content"></div>
          <!-- <img v-if="forumLouzhu.firstimg" :src="[forumLouzhu.firstimg]" alt /> -->
          <ul>
            <li v-for="item in forumLouzhu.srcList" :key="item.id">
              <img v-if="item" :src="[item]" alt />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="forum_list">
      <div class="forum_item" v-for="item in forumList" :key="item.id">
        <div class="user">
          <img :src="[item.mpic]" alt />
          <div class="username">
            <p>{{ item.nickname }}</p>
            <p class="time">{{ item.createtime }}</p>
          </div>
        </div>
        <div class="ForumMain">
          <div class="Forum_content" v-html="item.content"></div>
          <img v-if="item.firstimg" :src="[item.firstimg]" alt />
        </div>
      </div>
    </div>
    <!-- 回复 -->
    <div class="huitie">
      <van-field
        v-model="huitie"
        rows="3"
        autosize
        label="回复 "
        type="textarea"
        maxlength="80"
        placeholder="请输入"
        show-word-limit
      />
      <input type="button" value="发表评论" class="btn" @click="postHuitie" />
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/common/Navbar.vue";

export default {
  name: "",
  components: {
    NavBar
  },
  props: {},
  data() {
    return {
      forumLouzhu: "",
      forumList: [],
      huitie: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getForum();
  },
  mounted() {},
  methods: {
    async getForum() {
      const res = await this.$http.get(
        "/home/api/getltmain?id=" + this.$route.query.id
      );
      console.log(res.data);
      this.forumLouzhu = {
        nickname: res.data.info.nickname,
        mpic: res.data.info.mpic,
        createtime: res.data.info.createtime,
        content: res.data.info.content,
        srcList: res.data.info.srcList
      };
      let forumItem = "";
      for (var i = 0; i < res.data.list.length; i++) {
        forumItem = {
          nickname: res.data.list[i].nickname,
          mpic: res.data.list[i].mpic,
          createtime: res.data.list[i].createtime,
          content: res.data.list[i].content,
          srcList: res.data.list[i].srcList
        };
        this.forumList.push(forumItem);
      }
    },
    async postHuitie() {
      if (!localStorage.getItem("id")) {
        this.$toast.success("请先登录");
        setTimeout(() => {
          this.$router.push("./Login");
        }, 1500);
        return false;
      }
      const res = await this.$http.post(
        "/home/api/addzfcon?id=" +
          this.$route.query.id +
          "&userid=" +
          localStorage.getItem("id") +
          "&content=" +
          this.huitie
      );
      console.log(res);
      // console.log(this.huitie);
      // console.log(this.$route.query.id);
      this.$toast.success("回复成功");
      this.$router.go(0);
    }
  }
};
</script>

<style scoped lang="scss">
.forum_louzhu {
  margin-top: 48px;
}
.forum_item {
  padding: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  .user {
    display: flex;
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
    }
    .username {
      margin-left: 10px;
      p {
        font-size: 12px;
        line-height: 16px;
      }
      p.time {
        font-size: 10px;
        color: #999;
      }
    }
  }
  .ForumMain {
    margin-top: 10px;
    .Forum_content {
      margin-bottom: 10px;
    }
    ul li {
      margin-bottom: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.huitie {
  .btn {
    display: block;
    margin: 10px auto 20px;
    border: 0;
    font-size: 14px;
    padding: 5px 10px;
    background: #fedf02;
  }
}
</style>
